import { UserState } from 'src/models/userOnlineList';

import { Callback } from 'src/util/query/models/Callback';

export class UserStatesCallback extends Callback<UserState[]> {
	public constructor(private readonly setUserStates: (userStates: Array<UserState>) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: UserState[]): void => {
		this.setUserStates(successResponse);
	};
}
